<div *ngIf="!isEdited" class="cell-view" style="justify-content: center">
  <div>
    <i
      [class]="rowData[fieldName]?.icon"
      [ngStyle]="{ color: rowData[fieldName]?.color }"
      [pTooltip]="rowData[fieldName]?.name"
      class="text-2xl"
    ></i>
  </div>
  <div *ngIf="editable" class="edit-menu">
    <button
      pButton
      id="cancelRowSelection"
      data-cy="IconCell_Button_edit"
      icon="pi pi-pencil"
      (click)="onEdit()"
    ></button>
    <button
      pButton
      *ngIf="!mandatory && rowData[fieldName] != null"
      id="cancelRowSelection"
      data-cy="IconCell_Button_cancel"
      icon="pi pi-trash"
      (click)="onDelete()"
    ></button>
  </div>
</div>

<ng-container *ngIf="isEdited">
  <ng-container *ngIf="showInputAsOverlay(minWidthPx); else woOverlay">
    <jml-lib-overlay [visible]="true" [widthPx]="2 * minWidthPx" overlayCssClass="p-1">
      <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
    </jml-lib-overlay>
  </ng-container>
</ng-container>

<ng-template #woOverlay>
  <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
</ng-template>

<ng-template #inputTpl>
  <div class="p-inputgroup">
    <p-dropdown
      #dropdown
      [placeholder]="rowData[fieldName] ? rowData[fieldName].tooltip : header ? header : '&nbsp;'"
      class="dropdown-full-width"
      [name]="fieldName"
      [options]="options"
      [panelStyle]="{ 'max-width': '250px' }"
      [style]="{ width: '100%' }"
      [(ngModel)]="rowData[fieldName]"
      (keyup.esc)="abortCellEdit($event)"
      (onChange)="
        isEdited = false;
        rowData[fieldName] = rowData[fieldName].id;
        completeCellEdit.emit({ data: rowData, field: fieldName })
      "
      (clickOutside)="abortCellEdit($event)"
      jmlAutoFocus
      jmlStopClickPropagation
      jmlClickOutside
      appendTo="body"
    >
      <ng-template let-item pTemplate="item">
        <i
          [class]="item.value.icon"
          [ngStyle]="{ color: item.value.color }"
          [pTooltip]="item.value.description"
          class="text-4xl vertical-align-middle pr-2"
        ></i>
        {{ item.label }}
      </ng-template>
    </p-dropdown>
  </div>
</ng-template>
